// extracted by mini-css-extract-plugin
export default {"Confirmation":"VideoComments_Confirmation__59gEa","box":"VideoComments_box__bzbTa","video_box":"VideoComments_video_box__eahtg"};